import { render, staticRenderFns } from "./videoWallNew.vue?vue&type=template&id=d1fb6046"
import script from "./videoWallNew.vue?vue&type=script&lang=js"
export * from "./videoWallNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports